<template>
  <div class="pg-kefu">
    <iframe
      v-if="url"
      :src="url"
      class="pg-kefu__frame"
      scrolling="auto"
      frameborder="0"
      title="在线客服"
      @load="frameLoaded = true"
    ></iframe>
    <div v-if="url && !frameLoaded" class="pg-kefu__state">正在加载客服...</div>
    <div v-if="error" class="pg-kefu__state pg-kefu__state--error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: '',
      frameOrigin: '',
      frameLoaded: false,
      error: '',
    };
  },
  created() {
    this.loadSupport();
  },
  mounted() {
    window.addEventListener('message', this.handleFrameMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleFrameMessage);
  },
  methods: {
    async loadSupport() {
      const loggedIn = Boolean(this.$store.state.token);
      const endpoint = loggedIn
        ? '/api/member/sso/lottery?destination=support'
        : '/api/lottery/support-url';
      try {
        const res = await this.$apiFun.get(endpoint, {});
        if (res.code !== 200 || !res.data || !res.data.url) throw new Error(res.message || '客服地址获取失败');

        this.url = this.withEmbeddedFlag(res.data.url);
        this.frameOrigin = new URL(this.url).origin;
      } catch (error) {
        this.error = '客服暂时无法打开，请稍后重试';
        console.error('load lottery support failed', error);
      }
    },
    withEmbeddedFlag(url) {
      const hashIndex = url.indexOf('#');
      if (hashIndex < 0) return `${url}${url.includes('?') ? '&' : '?'}embedded=1`;
      const base = url.slice(0, hashIndex);
      const hash = url.slice(hashIndex);
      return `${base}${hash}${hash.includes('?') ? '&' : '?'}embedded=1`;
    },
    handleFrameMessage(event) {
      if (!event.data || event.data.type !== 'pg-support-back') return;
      if (this.frameOrigin && event.origin !== this.frameOrigin) return;
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.pg-kefu {
  position: fixed;
  z-index: 1001;
  inset: 0;
  background: #f3f6fa;
}

.pg-kefu__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

.pg-kefu__state {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  padding: 12px 18px;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  background: rgba(23, 32, 51, 0.72);
  color: #fff;
  white-space: nowrap;
}

.pg-kefu__state--error {
  background: #fff;
  color: #66758a;
  box-shadow: 0 8px 24px rgba(23, 32, 51, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue